import type {
  TContactDetailsResponse,
  TContactDetailsStates,
  TKeyOnlyResponse,
  TKeyOnlyStates,
  TResendInviteResponse,
  TResendInviteStates,
} from '@/hooks/escript/useBeginEscriptSignup';
import { ContactDetailsStates, KeyOnlyStates, ResendInviteStates } from '@montugroup/circuit-api-contracts';

export function isKeyOnlyResponse(
  data: TKeyOnlyResponse | TResendInviteResponse | TContactDetailsResponse,
): data is TKeyOnlyResponse {
  return KeyOnlyStates.options.includes(data.onboardState as TKeyOnlyStates);
}

export function isResendInviteResponse(
  data: TKeyOnlyResponse | TResendInviteResponse | TContactDetailsResponse,
): data is TResendInviteResponse {
  return ResendInviteStates.options.includes(data.onboardState as TResendInviteStates);
}

export function isContactDetailsResponse(
  data: TKeyOnlyResponse | TResendInviteResponse | TContactDetailsResponse,
): data is TContactDetailsResponse {
  return ContactDetailsStates.options.includes(data.onboardState as TContactDetailsStates);
}
